<div class="form-modal modal-theme">
  <h1 mat-dialog-title>{{title|translate}}</h1>
  <div mat-dialog-content>
    <form [formGroup]="form" class="form-horizontal modal-dialog-custom">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <div class="col-sm-12">
              <mat-form-field class="full-width" [ngClass]="{ 'mat-input-invalid': formErrors.Notes || !form.controls.Notes.valid}">
                <textarea matInput placeholder="{{title|translate}}" formControlName="Notes" [rows]="10"></textarea>
              </mat-form-field>
              <span *ngIf="formErrors.Notes" class="field-validation-valid text-danger"
              [translate] [translateParams]="formErrorsParam.Notes">{{
                formErrors.Notes
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div mat-dialog-actions>
    <!-- Consulta -->
    <div class="full-width text-right" *ngIf="disabled">
      <button type="button" class="btn btn-default" [title]="'CLOSE'|translate" (click)="dialogRef.close(null)">
        {{'CLOSE'|translate}}
      </button>
    </div>
    <!-- Edição -->
    <div class="full-width text-right" *ngIf="!disabled">
      <button *ngIf="!mandatoryNotes" type="button" class="btn btn-default" [title]="'BUTTON.CANCEL'|translate" (click)="dialogRef.close(null)">
        <i class="fas fa-ban"></i>&nbsp;{{'BUTTON.CANCEL'|translate}}
      </button>
      <button type="button" class="btn btn-primary" [title]="'BUTTON.SAVE'|translate" (click)="save()"
        [disabled]="!form.valid || (!changedForm && enableSavingWhenChangingForm)">
        <i class="far fa-save"></i>&nbsp;{{'BUTTON.SAVE'|translate}}
      </button>
    </div>
  </div>
</div>